import BaseCellHandler from './BaseCellHandler';
import TableChartWrapper from '@/views/storyboard/charts/table';
import {
    AggregationsChartData, MetricAggregationChartData,
    MetricTimelineAggregatedChartData,
    MetricTimelineHistogramChartData, MultiTermsTimelineChartData, TermsTimelineChartData,
    TimelineByDateChartData
} from 'entities/chartData';


export type TableChartData = (
    TimelineByDateChartData
    | AggregationsChartData
    | TermsTimelineChartData
    | MultiTermsTimelineChartData
    | MetricTimelineAggregatedChartData
    | MetricTimelineHistogramChartData
    | MetricAggregationChartData
);

class TableCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.performSearchQuery;

    renderContent() {
        const {data, queryDuration} = this.state;
        const {
            chartQuery, chartId, chartTitle, scalingFactor, chartSettingsView,
        } = this.props;

        return (
            <TableChartWrapper
                data={data! as TableChartData[]}
                chartId={chartId}
                chartQuery={chartQuery}
                chartTitle={chartTitle}
                scalingFactor={scalingFactor}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
            />
        );
    }
}

export default TableCellHandler;
